"use strict";

exports.__esModule = true;
exports.createQueryKeyManager = void 0;

var createQueryKeyManager = function createQueryKeyManager() {
  var queriesToUpdate = {};

  var getQueryKeysToUpdate = function getQueryKeysToUpdate(queryName) {
    return queriesToUpdate[queryName] || [];
  };

  return {
    addQuery: function addQuery(queryName, queryKey) {
      var existingQueryKeys = getQueryKeysToUpdate(queryName);

      if (!existingQueryKeys.some(function (key) {
        return JSON.stringify(key) === JSON.stringify(queryKey);
      })) {
        queriesToUpdate[queryName] = getQueryKeysToUpdate(queryName).concat([queryKey]);
      }
    },
    removeQuery: function removeQuery(queryName, queryKey) {
      queriesToUpdate[queryName] = getQueryKeysToUpdate(queryName).filter(function (key) {
        return JSON.stringify(key) !== JSON.stringify(queryKey);
      });
    },
    hasQueryToUpdate: function hasQueryToUpdate(queryName) {
      return getQueryKeysToUpdate(queryName).length > 0;
    },
    getQueryKeysToUpdate: getQueryKeysToUpdate
  };
};

exports.createQueryKeyManager = createQueryKeyManager;